<template>
	<div class="course-test">
		<template v-for="(courseTest, index) in courseTests">
			<div :key="index" class="course">
				<div class="container-fluid">
					<div class="course-test-wrapper">
						<div class="content">
							<h6 class="title">{{ courseTest.question_set.set_name }}</h6>
							<!--<div class="description" v-html="courseTest.lecture_description"></div>-->
						</div>
						<div class="actions">
							<button
								class="btn btn-learning"
								@click="$router.push(`/elearning/${courseID}/${courseTest.question_set_id}`)">
								ทดสอบ
							</button>
						</div>
					</div>
				</div>
			</div>
		</template>
	</div>
</template>

<script>
  export default {
    name: 'course-test',

    props: {
      courseTests: {
        type: Array,
        default: null
      },
      'courseID': {
        type: String,
        default: ''
      }
    },

    watch: {
      courses: val => {
        this.courses = val
      }
    }
  }
</script>

<style lang="scss" scoped>
	@import "../../styles/styles";

	.course-test {
		padding: 20px 0;
		.course {
			padding: 40px 0 20px;
			&:not(:last-child) {
				border-bottom: 1px solid $border-color;
			}
			.course-test-wrapper {
				@extend .d-flex;
				@extend .align-items-center;
				.content {
					@extend .flex-grow-1;
					h6, .description {
						margin-bottom: 0;
						font-size: 14px;
					}
				}
				.actions {
					@extend .align-self-baseline;
				}
			}
		}
	}
</style>



// WEBPACK FOOTER //
// src/components/learning/CourseTest.component.vue